import PortalIdParser from 'PortalIdParser';
export const getCreateTeamsURL = () => `/settings/${PortalIdParser.get()}/users/teams`;